import { useRef, useState } from "react";
import AdminNavbar from "./AdminNavbar";

const AdminAirdrop = () => {
  const [tokenName, setTokenName] = useState("");
  const [respMessage, setRespMessage] = useState();
  const [tokenTicker, setTokenTicker] = useState("");
  const [airdropAmt, setAirdropAmt] = useState("");
  const [image, setImage] = useState(null);
  const [airdropStart, setAirdropStart] = useState("");
  const [airdropEnd, setAirdropEnd] = useState("");
  const [tokenDescription, setTokenDescription] = useState("");
  const [airdropEligibility, setAirdropEligibility] = useState("");
  const [chain, setChain] = useState("");
  const imageInputRef = useRef(null);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setRespMessage("");

    const formData = new FormData();
    formData.append("tokenName", tokenName);
    formData.append("tokenTicker", tokenTicker);
    formData.append("airdropAmt", airdropAmt);
    formData.append("airdropStart", airdropStart);
    formData.append("airdropEnd", airdropEnd);
    formData.append("tokenDescription", tokenDescription);
    formData.append("airdropEligibility", airdropEligibility);
    formData.append("chain", chain);
    formData.append("image", image);

    try {
      //   const res = await fetch("http://localhost:8080/api/feedback", {
      const res = await fetch(
        "https://airdrop-production-61b7.up.railway.app/api/create/airdrop",
        {
          method: "POST",
          body: formData,
        }
      );
      const data = await res.json();
      if (res.ok) {
        setRespMessage("Feedback submitted successfully");
        setTokenName("");
        setTokenDescription("");
        setTokenTicker("");
        setAirdropEligibility("");
        setAirdropStart("");
        setAirdropEnd("");
        setChain("");
        setAirdropAmt("");
        imageInputRef.current.value = null;
      } else {
        setRespMessage(`Error: ${data.error}`);
      }
    } catch (error) {
      setRespMessage("Failed to connect to the server.");
    }
  };

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };
  return (
    <>
      {" "}
      <AdminNavbar />
      <div className="admin-dashboard-pg">
        <div className="admin_news adm">
          <h3 className="text-center mb-4">Airdrop</h3>
          <div className="container">
            {" "}
            <form onSubmit={handleSubmit}>
              <div className="mb-airdrop">
                <label>Token Name: </label> <br />
                <input
                  type="text"
                  value={tokenName}
                  onChange={(e) => setTokenName(e.target.value)}
                />
              </div>
              <div className="mb-airdrop">
                <label>Ticker: </label> <br />
                <input
                  type="text"
                  value={tokenTicker}
                  onChange={(e) => setTokenTicker(e.target.value)}
                />
              </div>{" "}
              <div className="mb-airdrop">
                <label>Token Image: </label> <br />
                <input
                  type="file"
                  name="image"
                  onChange={handleImageChange}
                  ref={imageInputRef}
                />
              </div>{" "}
              <div className="mb-airdrop">
                <label>Chain: </label> <br />
                <input
                  type="text"
                  value={chain}
                  onChange={(e) => setChain(e.target.value)}
                />
              </div>
              <div className="mb-airdrop">
                <label>Airdrop Amount: </label> <br />
                <input
                  type="text"
                  value={airdropAmt}
                  onChange={(e) => setAirdropAmt(e.target.value)}
                />
              </div>{" "}
              <div className="mb-airdrop">
                <label>Airdrop (starts from): </label> <br />
                <input
                  type="date"
                  value={airdropStart}
                  onChange={(e) => setAirdropStart(e.target.value)}
                />
              </div>
              <div className="mb-airdrop">
                <label>Airdrop (ends on): </label> <br />
                <input
                  type="date"
                  value={airdropEnd}
                  onChange={(e) => setAirdropEnd(e.target.value)}
                />
              </div>{" "}
              <div className="mb-airdrop">
                <label>Token Description: </label> <br />
                <textarea
                  style={{ width: "62%", resize: "none", height: "5rem" }}
                  value={tokenDescription}
                  onChange={(e) => setTokenDescription(e.target.value)}
                />
              </div>
              <div className="mb-airdrop">
                <label>Eligibility: </label> <br />
                <textarea
                  style={{ width: "62%", resize: "none", height: "10rem" }}
                  value={airdropEligibility}
                  onChange={(e) => setAirdropEligibility(e.target.value)}
                />
              </div>{" "}
              <button type="submit">Submit</button>
            </form>{" "}
            {respMessage && <p>{respMessage}</p>}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminAirdrop;
